import React, { createRef } from "react";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { FaPlus, FaRegTrashAlt } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa6";
import { admission_docs, admission_extra_docs } from "../helpers/Documents";

const FilePicker = ({
  name,
  file,
  setFile,
  height = 150,
  admissionID,
  uploadable,
  center_uuid,
  error,
}) => {
  const fileRef = createRef();
  const API_URL = process.env.REACT_APP_API_URL;
  const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
  const MAX_FILE_SIZE = 2;

  const handleFileChange = (e) => {
    const reader = new FileReader();

    const selectedFile = e.target.files[0];

    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }

    // Validate file type
    if (
      !selectedFile.type.includes("image") &&
      !selectedFile.type.includes("pdf")
    ) {
      toast.error(<FormattedMessage id="error.file_picker" />);
      return;
    }

    // Validate file size
    if (selectedFile.size > MAX_FILE_SIZE * 1024 * 1024) {
      toast.error(<FormattedMessage id="error.large_file" />);
      return;
    }

    reader.onload = (readerEvent) => {
      if (!selectedFile.type.includes("pdf")) {
        selectedFile.preview = readerEvent.target.result;
      } else {
        selectedFile.preview = ".pdf";
      }

      // If uploadable is true, then upload the file
      if (uploadable) {
        handleUpload(selectedFile);
      } else {
        setFile(selectedFile);
      }
    };
  };

  const handleUpload = async (file) => {
    const name = fileRef.current.name;
    try {
      const fD = new FormData();
      fD.append("file", file);
      fD.append("field_name", name);
      fD.append("admission_id", admissionID);
      const response = await fetch(`${API_URL}/upload-doc`, {
        method: "POST",
        body: fD,
      });
      if (response.ok) {
        const data = await response.json();
        const { data: resData } = data;

        console.log("data", resData[name]);
        file.preview = `${
          PORTAL_URL + center_uuid[resData.center_id]
        }/admissions_school/${resData[name]}`;
        setFile(file);
        toast.success(<FormattedMessage id="validation.file_uploaded" />);
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  const handleDelete = async () => {
    if (uploadable) {
      let table_name = "";

      if (admission_docs.includes(name)) {
        table_name = "admissions";
      } else if (admission_extra_docs.includes(name)) {
        table_name = "admission_extra_info";
      }

      try {
        const fD = new FormData();
        fD.append("field_name", name);
        fD.append("table_name", table_name);
        fD.append("admission_id", admissionID);
        const response = await fetch(`${API_URL}/delete-doc`, {
          method: "POST",
          body: fD,
        });
        if (response.ok) {
          setFile(null);
          fileRef.current.value = null;
          toast.success(<FormattedMessage id="validation.file_deleted" />);
        } else {
          console.log("NOT OK");
        }
      } catch (error) {
        console.log("Error!");
        console.log(error);
      }
    } else {
      setFile(null);
      fileRef.current.value = null;
    }
  };

  return (
    <div
      style={{
        flexDirection: "column",
      }}
      className="pic-prev d-flex justify-content-center"
    >
      <div
        style={{
          borderRadius: 15,
          borderStyle: "dashed",
          borderWidth: 2,
          borderColor: "#ced4da",
          height: height,
          display: "flex",
          overflow: "hidden",
        }}
      >
        {file ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              flex: 1,
              position: "relative",
            }}
          >
            <button
              style={{
                padding: 3,
                border: 3,
                background: "none",
                position: "absolute",
                top: 0,
                right: 5,
              }}
              onClick={handleDelete}
            >
              <FaRegTrashAlt style={{ color: "#dc3545" }} />
            </button>
            {file.preview.includes(".pdf") ? (
              <div
                onClick={() => {
                  uploadable && window.open(file.preview, "_blank");
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: uploadable ? "pointer" : "default",
                }}
              >
                <FaRegFilePdf
                  style={{
                    fontSize: 40,
                  }}
                />
              </div>
            ) : (
              <img
                onClick={() => {
                  uploadable && window.open(file.preview, "_blank");
                }}
                style={{
                  cursor: uploadable ? "pointer" : "default",
                }}
                src={file.preview}
                alt=""
                width="100"
              />
            )}
          </div>
        ) : (
          <button
            onClick={() => fileRef.current.click()}
            style={{
              background: "none",
              border: 0,
              flex: 1,
            }}
          >
            <FaPlus />
          </button>
        )}
      </div>
      <em>
        <small className="text-danger" style={{ fontSize: 11 }}>
          <FormattedMessage id="note.max_allowed_size" />{" "}
          <strong>({MAX_FILE_SIZE}MB)</strong>
        </small>
      </em>
      {error && (
        <small className="text-danger mt-1" style={{ fontSize: 12 }}>
          <FormattedMessage id="error.document" />
        </small>
      )}
      <Form.Control
        name={name}
        className="d-none"
        ref={fileRef}
        type="file"
        onChange={handleFileChange}
        accept={".jpg, .jpeg, .png, .pdf"}
      />
    </div>
  );
};

export default FilePicker;
